import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-100 flex items-center flex-col mt-4" }
const _hoisted_2 = {
  style: {"height":"200px","width":"200px"},
  class: "border-4 border-blue-800 rounded-3xl relative"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoadingSpinner = _resolveComponent("LoadingSpinner")!
  const _component_QrStream = _resolveComponent("QrStream")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_LoadingSpinner, { isLoading: _ctx.isLoading }, null, 8, ["isLoading"]),
      _createVNode(_component_QrStream, {
        onDecode: _ctx.readQRCode,
        onInit: _ctx.handleInit
      }, {
        default: _withCtx(() => _cache[0] || (_cache[0] = [
          _createElementVNode("div", {
            style: {"color":"red"},
            class: "frame"
          }, null, -1)
        ])),
        _: 1
      }, 8, ["onDecode", "onInit"])
    ]),
    _cache[1] || (_cache[1] = _createElementVNode("span", { class: "mt-1" }, "aponte para o qrcode", -1))
  ]))
}